// Копирование в буфер обмена — ОДИН приём на весь веб (волна F, задача 8, C2).
//
// Зачем отдельный модуль. `navigator.clipboard` есть не всегда: его нет на
// http-странице (а веб открывают и с локального адреса), нет без разрешения, и
// он бросает в приватном окне. Это не поломка, а обычное состояние, и
// share-modal.ts с самого начала носил на этот случай фолбэк — выделить поле и
// позвать `document.execCommand('copy')`. Лист управления песней копировал
// адрес БЕЗ фолбэка и при этом всегда писал на кнопке «Скопировано»: на
// http-странице интерфейс сообщал о сделанном, чего он не делал.
//
// Приём перенесён сюда целиком, чтобы копия у него была одна: две расходятся
// молча в момент, когда одну поправят, а другую забудут.
//
// Главное здесь — ВОЗВРАТ. Функция отвечает, получилось ли, и вызывающий
// подтверждает действие только по факту. Копирование ничем себя не
// показывает — буфер невидим, — поэтому соврать про него особенно легко и
// особенно незаметно.

/**
 * Положить текст в буфер обмена. `true` — получилось.
 *
 * `fallbackField` — поле, в котором ЭТОТ ЖЕ текст уже стоит (адрес только для
 * чтения рядом с кнопкой). Без него фолбэка нет: `execCommand('copy')`
 * копирует ВЫДЕЛЕНИЕ, то есть копировать ему нечего, а выделять чужой текст на
 * странице ради этого — сделать что-то, о чём никто не просил.
 */
export async function copyText(text: string, fallbackField?: HTMLInputElement | HTMLTextAreaElement | null): Promise<boolean> {
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch {
    // Нет разрешения, приватное окно, небезопасный контекст — не поломка, а
    // повод попробовать по-старому.
  }
  try {
    if (fallbackField) {
      fallbackField.select();
      return document.execCommand('copy');
    }
  } catch {
    // execCommand снят браузером или запрещён — ответ ниже честный.
  }
  return false;
}
